import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE, UPLOADS_BASE } from '../apiConfig';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

// The portal handles image uploads to these paths, so we prepend its host.
// Fallback to localhost:8000 for local dev if not defined in env.
const PORTAL_BASE_URL = process.env.REACT_APP_PORTAL_BASE_URL || 'http://localhost:8000';
const getImageUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${PORTAL_BASE_URL}/${path.replace(/^\/+/, '')}`;
};

function Events() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        const EVENTS_API_URL = process.env.REACT_APP_PORTAL_BASE_URL
            ? `${process.env.REACT_APP_PORTAL_BASE_URL}/api/site/events`
            : 'https://portal.petrochoice.ae/api/site/events';

        axios
            .get(EVENTS_API_URL)
            .then((res) => {
                if (res.data && res.data.success) {
                    setEvents(res.data.data || []);
                } else {
                    setEvents(res.data || []); // Fallback just in case
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching events:', err.message);
                setError('Failed to load events');
                setLoading(false);
            });
    }, []);

    return (
        <div style={{ paddingTop: '10px', minHeight: '80vh' }} className="container mb-5">
            <div className="text-center mb-5" data-aos="fade-up">
                <h1 style={{ color: '#1565c0', fontWeight: 'bold' }}>Company Events</h1>
                <p className="text-muted">Stay updated with our latest activities and gatherings.</p>
                <div style={{ width: '60px', height: '4px', backgroundColor: '#f77c00', margin: '0 auto' }}></div>
            </div>

            {loading && <div className="text-center">Loading events...</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            {!loading && !error && events.length === 0 && (
                <div className="text-center py-5 my-5" data-aos="fade-up" style={{ backgroundColor: '#f8f9fa', borderRadius: '15px', border: '1px dashed #dee2e6' }}>
                    <div style={{ fontSize: '80px', color: '#cce5ff', marginBottom: '20px' }}>
                        <i className="fas fa-calendar-times"></i>
                    </div>
                    <h3 style={{ color: '#0a3161', fontWeight: 'bold' }}>No Events Scheduled</h3>
                    <p className="text-muted mb-4 mx-auto" style={{ fontSize: '18px', maxWidth: '500px' }}>
                        We don't have any upcoming events at the moment. We are constantly planning new activities, so please check back later!
                    </p>
                    <Link to="/" className="btn btn-primary px-4 py-2" style={{ borderRadius: '25px', backgroundColor: '#f77c00', borderColor: '#f77c00', fontWeight: '600' }}>
                        Return to Home
                    </Link>
                </div>
            )}

            <div className="row">
                {events.map((evt, idx) => (
                    <div key={evt.id} className="col-md-6 col-lg-4 mb-4" data-aos="zoom-in" data-aos-delay={idx * 100}>
                        <div className="card h-100 shadow-sm border-0" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                            <img
                                src={evt.image_url ? getImageUrl(evt.image_url) : '/assets/about us im 01.jpeg'}
                                alt={evt.title}
                                className="card-img-top"
                                style={{ height: '220px', objectFit: 'cover' }}
                            />
                            <div className="card-body">
                                <h5 className="card-title fw-bold" style={{ color: '#333' }}>{evt.title}</h5>
                                <p className="text-muted small mb-2">
                                    <i className="fa fa-calendar-alt me-2"></i>
                                    {new Date(evt.date).toLocaleDateString()}
                                    {evt.location && <span className="ms-3"><i className="fa fa-map-marker-alt me-2"></i>{evt.location}</span>}
                                </p>
                                <p className="card-text text-secondary mt-3">{evt.description}</p>
                                <span className={`badge ${evt.status === 'upcoming' ? 'bg-primary' : 'bg-secondary'}`}>
                                    {evt.status ? evt.status.toUpperCase() : 'EVENT'}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Events;
